import { ACTIONS as attemptingQuespayloadActions } from 'actions/attempting-questions-payload';

const initialState = {};

export default function defaultExport(state = initialState, { type, payload }) {
  if (type === attemptingQuespayloadActions.SET_STUDENT_QUESTION_UPDATE) {
    const { responseId, response, currentItem } = payload || {};
    const { eventType } = response || {};

    return { ...state, [responseId]: { ...response, currentItem, eventType } };
  }

  if (type === attemptingQuespayloadActions.SET_STUDENT_QUESTION_METADATA) {
    const { responseMeta: metaData, id: responseId, eventType } = payload || {};

    const prevStateResponse = state[responseId] || {};
    const { metadata: prevMetaData } = prevStateResponse || {};

    return {
      ...state,
      [responseId]: {
        ...prevStateResponse,
        eventType,
        metadata: { ...prevMetaData, ...metaData },
      },
    };
  }

  return state;
}
